import { render, staticRenderFns } from "./TourAccommodation.vue?vue&type=template&id=53388ac7&scoped=true&"
import script from "./TourAccommodation.vue?vue&type=script&lang=js&"
export * from "./TourAccommodation.vue?vue&type=script&lang=js&"
import style0 from "./TourAccommodation.vue?vue&type=style&index=0&id=53388ac7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53388ac7",
  null
  
)

export default component.exports